import React from 'react';
import { Link } from 'react-router-dom';
import './Insurance.scss';

const Insurance = () => {
  return (
    <div className="insurance-page">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="container">
          <div className="hero-content">
            <h1>Conversational AI for Insurance Businesses</h1>
            <p>
              Transform your organization's efficiency and communicate with customers more 
              effectively with our AI insurance chatbot for insurance companies.
            </p>
            <Link to="/contact" className="cta-button">Request Demo</Link>
          </div>
        </div>
      </section>

      {/* Feature Grid */}
      <section className="feature-grid">
        <div className="container">
          <div className="grid">
            <div className="feature-item">
              <div className="icon">
                <i className="fas fa-comments"></i>
              </div>
              <h3>Automated Answering of Queries</h3>
              <p>Chatbots can answer most customer queries, significantly cutting your employees' workloads.</p>
            </div>

            <div className="feature-item">
              <div className="icon">
                <i className="fas fa-file-invoice"></i>
              </div>
              <h3>Manage Claims with Ease</h3>
              <p>Simplify the job of claims handlers by making policy details more easily retrievable.</p>
            </div>

            <div className="feature-item">
              <div className="icon">
                <i className="fas fa-cogs"></i>
              </div>
              <h3>Improved Underwriting</h3>
              <p>By enabling faster data collection, chatbots can help you underwrite policies more effectively.</p>
            </div>

            <div className="feature-item">
              <div className="icon">
                <i className="fas fa-customize"></i>
              </div>
              <h3>Tailored to Your Business</h3>
              <p>Our chatbots are tailored to your organization and its unique procedures and goals.</p>
            </div>

            <div className="feature-item">
              <div className="icon">
                <i className="fas fa-shield-alt"></i>
              </div>
              <h3>Fraud Detection Functionality</h3>
              <p>Our chatbots can automatically detect indicators of fraud and notify the relevant departments.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="content-section">
        <div className="container">
          <div className="content-grid">
            <div className="content-left">
              <h2>Internal and customer-facing functionality</h2>
              <p>
                Handle quotes and claims more efficiently. Improve customer satisfaction
                Ease the pressure on your workforce
              </p>
              <p>
                Customer service is a fundamental part of the insurance industry, so why rely on an old outdated system? 
                Our insurance chatbots are built using intelligent machine learning algorithms to understand complex speech 
                patterns and dramatically simplify customer interactions. With our specialized AI insurance chatbots, you 
                can manage more queries, streamline the claims process, and improve customer satisfaction, all while 
                spending less than ever on your customer service.
              </p>
              <p>
                Insurance is a truly global industry, spanning almost all other industries to provide vital services to 
                countless businesses and individuals. But somehow, insurers have often failed to adapt to technological 
                innovations. This is holding back many providers, making operations inefficient, slow, and more expensive 
                than necessary. Chatbots for insurance offer a solution.
              </p>
            </div>
            <div className="content-right">
              <h3>AI insurance chatbots help insurers:</h3>
              <ul>
                <li>Handle claims faster</li>
                <li>Automate interactions with customers</li>
                <li>Streamline internal operations</li>
                <li>Onboard customers</li>
                <li>Link up disconnected services</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Insurance; 